import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import useOnce from '../../hooks/useOnce';
import axios from '../../services/MyAxios';

import LotteryRuleTierDetails from './LotteryRuleTierDetails';
import LotteryRuleTierMetrics from './LotteryRuleTierMetrics';

export default function LotteryRuleTierShow() {
    const { slug } = useParams();
    const { id } = useParams();
    const [tier, setTier] = useState({});
    const url = `/crea/api/lottery/${slug}/rule_tiers/${id}`;
    const metricsUrl = `/crea/api/metrics/${slug}/${id}`;

    useOnce(async () => setTier((await axios.get(url)).data));

    return (
        <>
            <LotteryRuleTierMetrics url={metricsUrl} />
            <LotteryRuleTierDetails tier={tier} />
        </>
    );
}
